import { apiSlice } from "../api/apiSlice";

export const assignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizzes: builder.query({
      query: () => `/quizzes`,
    }),
    getQuiz: builder.query({
      query: (id) => `/quizzes/${id}`,
    }),
    getQuizForVideo: builder.query({
      query: (id) => `/quizzes/?video_id=${id}`,
    }),
    addQuiz: builder.mutation({
      query: ({ data }) => ({
        url: "/quizzes",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const quiz = await queryFulfilled;

          if (quiz?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getQuizzes",
                undefined,
                (draft) => {
                  // Update the relevant task in the tasks array
                  draft.push(quiz?.data);

                  return draft;
                }
              )
            );
          }
        } catch {}
      },
    }),
    editQuiz: builder.mutation({
      query: ({ id, data }) => ({
        url: `/quizzes/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const quiz = await queryFulfilled;

          if (quiz?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getQuizzes",
                undefined,
                (draft) => {
                  // Update the relevant task in the tasks array
                  const quizIndex = JSON.stringify(
                    // eslint-disable-next-line
                    draft.findIndex((quiz) => quiz.id == arg?.id)
                  );

                  Object.assign(draft[quizIndex], quiz?.data);

                  return draft;
                }
              )
            );
          }
        } catch {}
      },
    }),
    deleteQuiz: builder.mutation({
      query: (id) => ({
        url: `/quizzes/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
            // Update the relevant task in the tasks array
            // eslint-disable-next-line
            const quizIndex = JSON.stringify(
              // eslint-disable-next-line
              draft.findIndex((quiz) => quiz.id == arg)
            );

            // eslint-disable-next-line
            return draft.filter((quiz) => quiz.id != arg);
          })
        );
        // optimistic cache update end
        try {
          await queryFulfilled;
        } catch {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetQuizzesQuery,
  useGetQuizQuery,
  useGetQuizForVideoQuery,
  useAddQuizMutation,
  useEditQuizMutation,
  useDeleteQuizMutation,
} = assignmentsApi;
